<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Configurações"
          newText="Nova Configuração"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="true"
          :enableDelete="false"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "configuracoesTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "painel", "cns", "classifica_risco", "integra_ares_triagem", "tipo_pessoa", "actions"],
      tableData: ["id", "painel", "cns", "classifica_risco", "integra_ares_triagem", "tipo_pessoa"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        sortable: ["id"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          painel: "Painel",
          cns: "CNS",
          classifica_risco: "Classifica Risco",
          integra_ares_triagem: "Integração Ares Triagem",
          tipo_pessoa: "Label Pessoa",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          painel: function(h, row, index) {
            return row.painel ? (<span class="badge badge-primary">Ativo</span>) : (<span class="badge badge-secondary">Inativo</span>);
          },
          cns: function(h, row, index) {
            return row.cns ? (<span class="badge badge-primary">Ativo</span>) : (<span class="badge badge-secondary">Inativo</span>);
          },
          classifica_risco: function(h, row, index) {
            return row.classifica_risco ? (<span class="badge badge-primary">Ativo</span>) : (<span class="badge badge-secondary">Inativo</span>);
          },
          integra_ares_triagem: function(h, row, index) {
            return row.integra_ares_triagem ? (<span class="badge badge-primary">Ativo</span>) : (<span class="badge badge-secondary">Inativo</span>);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "configuracoes/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-users";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.usersCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        painel: "painel",
        cns: "cns",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>